import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {ItemProposta, Proposta, ValoresTitulosDetalhado} from 'src/app/core/viewModel/proposta.model';
import {FormGroup} from '@angular/forms';
import {
    BASICO,
    BASICO_TRIPLO,
    BLACK,
    BLACK_TRIPLO,
    COMPLETO,
    COMPLETO_TRIPLO,
    COUNT_DIARIAS_DEFAULT,
    EXCLUSIVO,
    EXCLUSIVO_TRIPLO,
    ID_PRICE_BOOK,
    IDEAL,
    IDEAL_TRIPLO,
    PLUS,
    PLUS_TRIPLO,
    REQUINTE,
    REQUINTE_TRIPLO
} from '../../app.constants';
import {Planos} from '../../core/viewModel/planos.model';
import {HostListener, Injector} from '@angular/core';
import {AppComponent} from '../../app.component';
import * as jwt_decode from 'jwt-decode';
import {CategoriaPlanoService} from '../../core/services/categoria_plano.service';
import {CupomService} from '../../core/services/cupom.service';
import {CepService} from '../../core/services/cep.service';
import {PropostaService} from '../../core/services/proposta.service';
import {ICarrinho} from '../../shared/interfaces/carrinho.interface';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {ProdutoService} from '../../core/services/produto.service';

export class BasePropostaComponent extends BaseComponents {

    protected constructor(protected injector: Injector) {
        super(injector);
        this.cupomService = injector.get(CupomService);
        this.propostaService = injector.get(PropostaService);
        this.router = injector.get(Router);
        this.toast = injector.get(ToastrService);
        this.cepService = injector.get(CepService);
        this.categoriaPlanoService = injector.get(CategoriaPlanoService);
        this.appComponent = injector.get(AppComponent);
        this.titleService = injector.get(Title);
        this.produtoService = injector.get(ProdutoService);
        this.meta = injector.get(Meta);
    }

    static COUNT_DIARIAS_DEFAULT = 7;
    static COUNT_PESSOAS_DEFAULT = 2;
    static COUNT_QUARTOS_DEFAULT = 1;
    public idPriceBook = ID_PRICE_BOOK;
    public fidelizacaoCliente = true;
    protected cupomService: CupomService;
    protected propostaService: PropostaService;
    protected router: Router;
    protected toast: ToastrService;
    protected cepService: CepService;
    protected categoriaPlanoService: CategoriaPlanoService;
    protected appComponent: AppComponent;
    protected titleService: Title;
    protected produtoService: ProdutoService;
    protected meta: Meta;
    public minDiaria: number = COUNT_DIARIAS_DEFAULT;
    timeoutClick: any;
    public showMaisPlanos = true;
    public carrinhos: ICarrinho[];
    public totalDiarias = 0;
    public cupom = '';
    public cupomSales = null;
    public isCupomValido: boolean = null;
    public mensagemCupom: string = null;
    public countDiarias = 7;
    public countPessoas = 2;
    public countQuartos = 1;
    public countQuartosDuplos = 0;
    public countQuartosTriplos = 0;
    public emailCliente = '';
    public propostaResult: Proposta;
    public isConforto = true;
    public isFacilita = false;
    public qtdDiarasConforto = 0;
    public propostaStorage: Proposta;

    public categoriaTitulo: any;
    public selectedCategoria: any;
    selectedCategoriaQuery: any;
    public selectedTypeValue = 2;
    public planos: Planos[] = [];
    public planosAll: Planos[] = [];
    public planosDuplos: Planos[] = [];
    public planosTriplos: Planos[] = [];
    public plano: Planos;
    public typeValues = [{value: 2, label: 'Duplo'}, {value: 3, label: 'Triplo'}];
    public valorMensal: any;
    public valoresTitulosDetalhado: ValoresTitulosDetalhado;
    public text1: string;
    public text2: string;
    public params: any;
    public proposta: Proposta;
    public totalDuplos: 0;
    public totalTriplos: 0;
    public isMobile = false;
    public innerWidth: any;
    queryTipoPlano: any;
    queryQuarto: any;
    queryDiarias: any;
    isQueryParams = false;

    @HostListener('window:resize', ['$event'])
    onResize($event: Event) {
        this.handleMobile();
    }


    async inOnInit() {
        const {notAvailable, message, title} = this.isMaintenance();
        if (notAvailable) {
            this.toast.error(message, title, { timeOut: 5000});
            await this.router.navigate(['/']);
            return;
        }
        super.ngOnInit();
        this.setQueryParamTipoPlano();
        this.setUtmParams();
        await this.carregarDados();
    }

    setQueryParamTipoPlano() {
        if (this.params) {
            this.queryTipoPlano = this.params.tipoPlano;
            this.queryQuarto = this.params.quarto;
            this.queryDiarias = this.params.diarias;
            if (this.queryTipoPlano) {
                this.selectedCategoriaQuery = this.categoriaPlanoService.getCodigoPlanoPorNome(this.queryTipoPlano.toUpperCase());
                this.isQueryParams = true;
            }
            if (this.queryQuarto) {
                this.isQueryParams = true;
            }
            if (this.queryDiarias) {
                this.isQueryParams = true;
            }
        }
    }

    omitSpecialChar(event) {
        const regex = new RegExp('^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$');
        return !regex.test(event.key);
    }

    setUtmParams() {
        if (this.params) {
            const utmParams = {
                utm_campaign: (this.params.utm_campaign) ? this.params.utm_campaign : '',
                utm_medium: (this.params.utm_medium) ? this.params.utm_medium : '',
                utm_source: (this.params.utm_source) ? this.params.utm_source : '',
                utm_term: (this.params.utm_term) ? this.params.utm_term : '',
            };
            localStorage.setItem('mtl.utm', JSON.stringify(utmParams));
        }
    }

    getPlanoQuery() {
        let planos = this.planosDuplos;
        let plano = this.planosDuplos[1];
        let qtdDiariaPlano = plano.qtdDiarias[0];
        let isDuplo = true;
        if (this.queryQuarto) {
            if (this.queryQuarto.toUpperCase() === 'TRIPLO') {
                planos = this.planosTriplos;
                this.selectedCategoria = this.categoriaPlanoService.transitionType(this.selectedCategoria);
                this.selectedTypeValue = 3;
                isDuplo = false;

            }
        }
        if (this.selectedCategoriaQuery) {
            if (!isDuplo) {
                this.selectedCategoriaQuery = this.categoriaPlanoService.transitionType(this.selectedCategoriaQuery);
            }
            const data = planos.filter(item => item.codigoCategoria === this.selectedCategoriaQuery);
            if (data) {
                plano = data[0];
            }
        }
        if (this.queryDiarias) {
            if (this.queryDiarias >= 4 && this.queryDiarias <= 28) {
                const diariaPlano = plano.qtdDiarias.filter(item => +item.quantidadeDiarias === +this.queryDiarias);
                qtdDiariaPlano = (diariaPlano.length) ? diariaPlano[0] : qtdDiariaPlano;
            }
        }
        return { plano, qtdDiariaPlano, pessoas: isDuplo ? 2 : 3 };
    }

    async carregarDadosPropostaPadraoFacilita() {
        // await this.getCupomPadrao();
        await this.getPlanos();
        const { plano, qtdDiariaPlano,  pessoas } = this.getPlanoQuery();
        return {
            cupom:  '',
            cupomAceito: false,
            mensagemCupom: '',
            fidelizacaoCliente: this.fidelizacaoCliente,
            msgError: null,
            msgLimite: null,
            qtdPessoa: null,
            quartoDuplo: 0,
            quartoTriplo: 1,
            quartosPossiveis: null,
            valorAdesao: 'R$ 600,00',
            valorAdesaoDesconto: 'R$ 0,00',
            valorMensalidade: this.categoriaPlanoService.monthlyValueString(qtdDiariaPlano.descricao),
            valorMensalidadeDesconto: 'R$ 0,00',
            itensProposta: [
                {
                    categoriaTitulo: plano.descricao,
                    codigoCategoria: plano.codigoCategoria,
                    diarias: qtdDiariaPlano.quantidadeDiarias,
                    pessoas,
                    quartos: 1,
                    valor: qtdDiariaPlano.valor,
                    codigoCategoriaSales: plano.codigoCategoriaSales,
                    valoresTitulosDetalhado: [
                        {
                            categoriaDescricao: plano.descricao,
                            codigoCategoria: plano.codigoCategoria,
                            descricao: qtdDiariaPlano.descricao,
                            qtdTitulos: 1,
                            quantidadeDiarias: qtdDiariaPlano.quantidadeDiarias,
                            codigoCategoriaSales: plano.codigoCategoriaSales,
                        }
                    ]
                }
            ],
        };
    }

    async carregarDados() {
        let proposta;
        if (this.storageValido() && !this.isQueryParams) {
            proposta = this.getPropostaParaStorage();
        } else {
            proposta =  await this.carregarDadosPropostaPadraoFacilita();
        }
        await this.setProposta(proposta);
        if (this.cupom) {
            await this.validaCupom();
        } else {
            // await this.getCupomPadrao();
            await this.calculaValores();
            await this.validaCupom();
        }
        this.getCountQuartoDuplo(proposta);
        this.getCountQuartoTriplo(proposta);

    }

    calcularDesconto(money) {
        const valueDiscount = this.cupomSales.discount;
        const originalPrice = this.getOriginalPrice(money);
        const discount = valueDiscount > 0 ? +(originalPrice * valueDiscount) : originalPrice;
        const result = originalPrice - discount;
        return parseFloat(String(result)).toFixed(2);
    }
    getOriginalPrice(money) {
        if (typeof  money === 'string') {
            let originalPrice = null;
            originalPrice = money.split('R$');
            originalPrice = originalPrice[1];
            return +originalPrice.replaceAll(',', '.');
        }
        return money;
    }
    transformMoney(value) {
        const result = String(value).replace('.', ',');
        return `R$ ${result}`;
    }

    async validaCupom() {
        this.appComponent.showOverlay();
        this.isCupomValido = false;
        this.cupomSales = null;
        let result;
        if (this.cupom !== '') {
            result = await this.cupomService.validaSales(this.cupom);
            if (result) {
                const { data } = result;
                const { totalSize, records } = data;
                if (totalSize > 0) {
                    const record = records[0];
                    const { Validade__c, Qntde_desconto__c } = record;
                    const validate = new Date(Validade__c);
                    this.isCupomValido = validate > new Date();
                    this.cupomSales = this.isCupomValido ? {
                        validate,
                        discount: Qntde_desconto__c / 100,
                    } : null;
                }
            }
        }
        const proposta = this.propostaStorage;
        proposta.cupom = this.cupom;
        proposta.cupomAceito = this.isCupomValido;
        proposta.valorMensalidadeDesconto = this.transformMoney(proposta.valorMensalidade);
        if (proposta.cupomAceito) {
            const valorMensalidadeDesconto = this.calcularDesconto(proposta.valorMensalidade);
            proposta.valorMensalidadeDesconto = this.transformMoney(valorMensalidadeDesconto);
        }
        this.addPropostaParaStorage(proposta);
        await this.calcularValoresFacilita();
    }

    carregarEnderecoLocalStorage(form: FormGroup) {
        const proposta = this.getPropostaParaStorage();

        if (!proposta) {
            return;
        }

        if (proposta.cep) {
            form.get('cep').setValue(proposta.cep);
        }

        if (proposta.logradouro) {
            form.get('logradouro').setValue(proposta.logradouro);
        }

        if (proposta.numero) {
            form.get('numero').setValue(proposta.numero);
        }

        if (proposta.complemento) {
            form.get('complemento').setValue(proposta.complemento);
        }

        if (proposta.cidade && proposta.cidade.id) {
            form.get('codCidade').setValue(proposta.cidade.id);
        }

        if (proposta.bairro) {
            form.get('bairro').setValue(proposta.bairro);
        }
    }

    storageValido() {
        const storage = this.getPropostaParaStorage();
        return storage &&
            storage.itensProposta &&
            storage.itensProposta[0].diarias &&
            storage.itensProposta[0].pessoas &&
            storage.itensProposta[0].quartos;
    }

    async limpacupom() {
        this.isCupomValido = null;
        const proposta = this.propostaStorage;
        proposta.cupom = this.cupom;
        proposta.valorMensalidadeDesconto = this.transformMoney(proposta.valorMensalidade);
        this.addPropostaParaStorage(proposta);
        await this.calcularValoresFacilita();
        window.location.reload();
    }

    async getCupomPadrao() {
        const result = await this.cupomService.get();
        if (!result.error) {
            this.cupom = result.data[0].cupom;
        }
    }

    categoriaTituloDescritivo() {
        if (this.isFacilita) {
           // return  this.categoriaTitulo;
            return '';
        }
        return this.isConforto ? 'Conforto' : 'Tranquilidade';
    }

    categoriaTituloTexto() {
        return this.isConforto ? 'CONFORTO' : 'TRANQUILIDADE';
    }

    async calculaValores() {
        if (this.isFacilita) {
            await this.validaCupom();
            return;
        }
        const info = {
            cupom: this.isCupomValido && this.cupom ? this.cupom : '',
            listaTitulos: [
                {
                    categoriaTitulo: this.categoriaTituloTexto(),
                    diarias: this.countDiarias,
                    pessoas: this.countPessoas,
                    quartos: this.countQuartos
                },
            ]
        };
        if (this.qtdDiarasConforto > 0) {
            info.listaTitulos.push({
                categoriaTitulo: 'CONFORTO',
                diarias: this.qtdDiarasConforto,
                pessoas: this.countPessoas,
                quartos: this.countQuartos
            });
        }
        const result = await this.propostaService.calculaValores(info);
        if (result.error) {
            this.resetarValues();
            this.toast.error(result.error.description, '', {
                timeOut: 5000
            });
        } else {
            if (result.data.msgError) {
                if (!this.resetarValues(result.data)) {
                    this.tratarErroApi(result.data);
                }
            } else {
                this.propostaResult = result.data;
                this.getCountQuartoDuplo(result.data);
                this.getCountQuartoTriplo(result.data);
                this.addPropostaParaStorage(this.propostaResult);
            }
        }
    }

    async calcularValoresFacilita() {
        this.appComponent.showOverlay();
        this.calcularTotalDiarias();
        if (this.totalDiarias > 28 && this.isMobile) {
            this.toast.error('o Número total de diárias não pode ultrapassar 28 diárias.', '', {
                timeOut: 5000
            });
            return;
        }
        const listaTitulos = this.carrinhos.map(element => {
            let categoriaTitulo = this.setToUpperCase(element.categoriaTitulo);
            categoriaTitulo = categoriaTitulo.replace('TRIPLO', '').trim();
            return {
                categoriaTitulo,
                diarias: +element.countDiarias,
                pessoas: element.selectedTypeValue,
                quartos: 1
            };
        });
        const payload = {
            cupom: this.isCupomValido && this.cupom ? this.cupom : '',
            listaTitulos
        };
        const result = await this.resultCalculoFacilita(payload);
        if (result !== null) {
            this.proposta = result;
            this.propostaResult = this.mountProposta();
            this.carrinhos = this.transformResultInCarrinho(result.itensProposta);
        }
        this.calcularTitulos();
        this.appComponent.hideOverlay();
    }

    mountProposta(): Proposta {
        this.categoriaTitulo = '';
        this.countTriplosDuplos(this.proposta.itensProposta);
        this.valorMensal = this.proposta.valorMensalidade;
        this.countDiarias = this.totalDiarias;
        return {
            cupomId: (this.isCupomValido) ? this.cupom : '',
            cupom: (this.isCupomValido) ? this.cupom : null,
            cupomAceito: this.isCupomValido,
            itensProposta: this.proposta.itensProposta,
            mensagemCupom: this.proposta.mensagemCupom,
            fidelizacaoCliente: this.fidelizacaoCliente,
            msgError: this.proposta.msgError,
            msgLimite: this.proposta.msgLimite,
            qtdPessoa: this.proposta.qtdPessoa,
            quartoDuplo: this.totalDuplos,
            quartoTriplo: this.totalTriplos,
            quartosPossiveis: this.proposta.quartosPossiveis,
            valorAdesao: this.proposta.valorAdesao,
            valorAdesaoDesconto: this.proposta.valorAdesaoDesconto,
            valorMensalidade: this.proposta.valorMensalidade,
            valorMensalidadeDesconto: this.proposta.valorMensalidadeDesconto
        };
    }

    calcularTotalDiarias() {
        let totalDiarias = 0;
        this.carrinhos.map(element => totalDiarias += element.countDiarias);
        this.totalDiarias = totalDiarias;
        if (this.totalDiarias >= 28) {
            this.zerarBotaoAdicionar();
            return;
        }
        this.showMaisPlanos = true;
    }

    zerarBotaoAdicionar() {
        this.carrinhos.forEach( element => element.last = false);
        this.showMaisPlanos = false;
    }

    calcularTitulos() {
        this.changeTitulo(BASICO, BASICO_TRIPLO);
        this.changeTitulo(COMPLETO, COMPLETO_TRIPLO);
        this.changeTitulo(IDEAL, IDEAL_TRIPLO);
        this.changeTitulo(EXCLUSIVO, EXCLUSIVO_TRIPLO);
        this.changeTitulo(REQUINTE, REQUINTE_TRIPLO);
        this.changeTitulo(PLUS, PLUS_TRIPLO);
        this.changeTitulo(BLACK, BLACK_TRIPLO);
        const last = this.carrinhos[this.carrinhos.length - 1].id;
        this.carrinhos.forEach( element => {
            if (element.id === last) {
                element.last = true;
            }
        });
    }

    changeTitulo(duplo: string, triplo: string) {
        const carrinhos = this.carrinhos;
        const data = [];
        let tituloTotalPessoas = 0;
        let tituloTotalValorMensal = 0;
        let tituloTotalValorMensalString = '';
        let tituloTotalDiaria = 0;
        carrinhos.forEach(element => {
            if (element.selectedCategoria === duplo || element.selectedCategoria === triplo) {
                element.last = false;
                tituloTotalPessoas = tituloTotalPessoas + element.selectedTypeValue;
                tituloTotalValorMensal = tituloTotalValorMensal + this.convertStringToFloat(element.valorMensalString);
                tituloTotalDiaria = tituloTotalDiaria + element.countDiarias;
                data.push(element);
            }
        });
        if (data.length > 0) {
            tituloTotalValorMensal = +parseFloat(String(tituloTotalValorMensal)).toFixed(2);
            tituloTotalValorMensalString = `R$ ${tituloTotalValorMensal}`;
            tituloTotalValorMensalString = tituloTotalValorMensalString.replace('.', ',');
            const last = data[data.length - 1].id;
            data.forEach( element => {
                if (element.id === last) {
                    const text = this.setText(
                        element.selectedCategoria,
                        tituloTotalValorMensalString,
                        tituloTotalPessoas.toString(),
                        tituloTotalDiaria
                    );
                    element.text1 = text.text1;
                    element.text2 = text.text2;
                    element.last = true;
                } else {
                    element.text1 = '';
                    element.text2 = '';
                }
                this.carrinhos.map(carrinho => {
                    if (carrinho.id === element.id) {
                        element.last = false;
                        carrinho = element;
                    }
                });
            });
        }
    }

    convertStringToFloat(value: string): number {
        const valueReplace = value.replace('R$', '').replace(',', '.').trim();
        return +parseFloat(valueReplace).toFixed(2);
    }

    private countTriplosDuplos(itensProposta: ItemProposta[]) {
        this.totalDuplos = 0;
        this.totalTriplos = 0;
        itensProposta.forEach(itens => {
            if (itens.pessoas === 2) {
                this.totalDuplos++;
            }
            if (itens.pessoas === 3) {
                this.totalTriplos++;
            }
        });

    }

    async resultCalculoFacilita(info: any) {
        const resultCalculo = await this.propostaService.calculaValores(info);
        if (resultCalculo.error) {
            // this.toast.error(resultCalculo.error.description, '', {
            //     timeOut: 5000
            // });
            return null;
        } else if (resultCalculo.data.msgError) {
            // this.tratarErroApi(resultCalculo.data);
            return null;
        } else {
            return  resultCalculo.data;
        }
    }

    async buscarCep($event, form: FormGroup) {
        const cep = form.get('cep').value;

        form.controls.cep.setErrors(null);
        if (cep && cep.length === 8) {
            const result = await this.cepService.buscaCep(cep);
            if (!result.error) {
                const endereco = result.data;
                form.get('codCidade').setValue(endereco.codCidade);
                form.get('bairro').setValue(endereco.bairro);
                form.get('logradouro').setValue(endereco.logradouro);
                form.get('numero').setValue(endereco.numero);
                if (form.get('bairro').value === null) {
                    form.get('bairro').setValue('bairro nulo');
                }
            } else {
                form.controls.cep.setErrors({cepIncorrect: true});
                this.toast.error('Digite um CEP válido', '', {
                    timeOut: 5000
                });
            }

        }
    }

    async buscarCepVia($event, form: FormGroup) {
        this.appComponent.showOverlay();
        const cep = form.get('cep').value;
        if (cep && cep.length === 8) {
            const result = await this.cepService.buscaCepVia(cep);
            if (!result.error) {
                const endereco = result.data;
                form.get('endereco').setValue(endereco.logradouro);
                form.get('bairro').setValue(endereco.bairro);
                form.get('numero').setValue(endereco.numero);
                form.get('cidade').setValue(endereco.localidade);
                form.get('uf').setValue(endereco.uf);
            }
        }
        this.appComponent.hideOverlay();
    }

    tratarErroApi(data) {
        if (data.msgLimite) {
            this.toast.error(data.msgLimite, '', {
                timeOut: 5000
            });
        } else {
            this.toast.error(data.msgError, '', {
                timeOut: 5000
            });
        }
    }

    resetarValues(apiResult = null) {
        if (apiResult && apiResult.quartosPossiveis) {
            this.countQuartos = apiResult.quartosPossiveis[0];
            return true;
        }

        this.countDiarias = BasePropostaComponent.COUNT_DIARIAS_DEFAULT;
        this.countPessoas = BasePropostaComponent.COUNT_PESSOAS_DEFAULT;
        this.countQuartos = BasePropostaComponent.COUNT_QUARTOS_DEFAULT;
        return false;
    }

    async iniciaProposta() {
        const info = {
            email: this.emailCliente,
        };

        const result = await this.propostaService.inicia(info);
        if (result.error) {
            this.toast.error('Falha na requisição.', '', {
                timeOut: 5000
            });
            return result;
        } else {
            return result;
        }
    }

    cleanCategoriaTitulo(categoria: string) {
        let result = categoria.toUpperCase();
        if (result === 'BÁSICO') {
            result = 'BASICO';
        }
        return result.replace('TRIPLO', '').replace('BÁSICO', 'BASICO').trim();
    }

    queryCarrinho() {
        if (this.isFacilita) {
            const listaTitulos = this.carrinhos.map(element => {
                return {
                    categoriaTitulo: this.cleanCategoriaTitulo(element.categoriaTitulo),
                    facilita: true,
                    codigoCategoria: element.selectedCategoria,
                    valor: element.valorMensal,
                    diarias: +element.countDiarias,
                    pessoas: element.selectedTypeValue,
                    quartos: 1
                };
            });
            return {
                cupom: this.cupom,
                listaTitulos
            };
        }
        return {
            cupom: this.cupom,
            listaTitulos: [
                {
                    categoriaTitulo: this.categoriaTituloTexto(),
                    diarias: this.countDiarias,
                    pessoas: this.countPessoas,
                    quartos: this.countQuartos
                }
            ]
        };
    }

    getCountQuartoDuplo(result) {
        result.itensProposta.forEach(c => {
            const detalhe = c.valoresTitulosDetalhado.filter(v => v.categoriaDescricao === 'TRANQUILIDADE DUPLO');

            detalhe.forEach(d => {
                this.countQuartosDuplos = d.qtdTitulos;
            });
        });
    }

    getCountQuartoTriplo(result) {
        result.itensProposta.forEach(c => {
            const detalhe = c.valoresTitulosDetalhado.filter(v => v.categoriaDescricao === 'TRANQUILIDADE TRIPLO');

            detalhe.forEach(d => {
                this.countQuartosTriplos = d.qtdTitulos;
            });
        });
    }

    getParametroBaseRD() {
        return {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                email: '',
                conversion_identifier: 'Carrinho_Site_Passo_1',
                cf_quantidade_de_diarias_0: this.countDiarias,
                cf_categoria_do_plano_0: this.categoriaTituloTexto(),
                cf_quantidade_de_pessoas: this.countPessoas,
                cf_quantidade_de_quartos_0: this.countQuartos,
                cf_valor: this.propostaResult
                        && this.propostaResult.valorMensalidadeDesconto
                        && this.propostaResult.valorMensalidadeDesconto.toString() !== 'R$ 0,00'
                            ? this.propostaResult.valorMensalidadeDesconto
                            : this.propostaResult.valorMensalidade,
                cf_cpf: '',
                cf_celular_pessoal: '',
                cf_data_de_nascimento: '',
                name: '',
            }
        };
    }

    addPropostaParaStorage(obj) {
        let objParaSalvar = obj;
        const proposta = this.getPropostaParaStorage();

        if (proposta) {
            objParaSalvar = { ...proposta, ...objParaSalvar };
        }

        localStorage.setItem('mtl.proposta', JSON.stringify(objParaSalvar));
    }

    getPropostaParaStorage() {
        return JSON.parse(localStorage.getItem('mtl.proposta'));
    }

    armazenarCliente(obj) {
        localStorage.setItem('montreal.cliente', JSON.stringify(obj));
    }

    armazenarClienteCpf(obj) {
        localStorage.setItem('montreal.cliente_cpf', JSON.stringify(obj));
    }

    armazenarTokenUsuario(obj) {
        localStorage.setItem('montreal.cliente.token', obj);
    }

    getTokenUsuario() {
        return localStorage.getItem('montreal.cliente.token');
    }

    getCliente() {
        return JSON.parse(localStorage.getItem('montreal.cliente'));
    }

    getClienteCpf() {
        return JSON.parse(localStorage.getItem('montreal.cliente_cpf'));
    }


    iniciarTimeout() {
        if (this.timeoutClick) {
            clearTimeout(this.timeoutClick);
        }

        this.timeoutClick = setTimeout(() => this.calculaValores(), 700);
    }

    maisQuarto() {
        this.countQuartos++;
        const result = this.propostaService.validarParametrosCalculo(this.countDiarias, this.countPessoas, this.countQuartos);

        if (result.quartos.indexOf(this.countQuartos) < 0) {
          const sortedArray = result.quartos.sort((a, b) => a - b);

          for (const v of sortedArray) {
            if (+v > this.countQuartos) {
              this.countQuartos = +v;
              this.iniciarTimeout();
              return;
            }
          }

          this.countQuartos--;
        } else {
          this.iniciarTimeout();
        }
      }

    menosQuarto() {
        this.countQuartos--;
        const result = this.propostaService.validarParametrosCalculo(this.countDiarias, this.countPessoas, this.countQuartos);

        if (result.quartos.indexOf(this.countQuartos) < 0) {
          const sortedArray = result.quartos.sort((a, b) => b - a);

          for (const v of sortedArray) {
            if (+v < this.countQuartos) {
              this.countQuartos = +v;
              this.iniciarTimeout();
              return;
            }
          }

          this.countQuartos++;
        } else {
          this.iniciarTimeout();
        }
      }

    maisDiaria() {
        if (this.isFacilita) {
            if (this.countDiarias <= 27) {
                this.countDiarias++;
                this.calculaValores();
            }
            return;
        }
        this.countDiarias++;
        const result = this.propostaService.validarParametrosCalculo(this.countDiarias, this.countPessoas, this.countQuartos);

        if (result.diarias.indexOf(this.countDiarias) < 0) {
          const sortedArray = result.diarias.sort((a, b) => a - b);

          for (const v of sortedArray) {
            if (+v > this.countDiarias) {
              this.countDiarias = +v;
              this.iniciarTimeout();
              return;
            }
          }

          this.countDiarias--;
        } else {
          this.iniciarTimeout();
        }
      }

    menosDiaria() {
        if (this.isFacilita) {
            if (this.countDiarias <= this.minDiaria) {
                return;
            }
            this.countDiarias--;
            this.calculaValores();
            return;
        }
        if (this.countDiarias <= 3) {
              return;
        }
        this.countDiarias--;
        const result = this.propostaService.validarParametrosCalculo(this.countDiarias, this.countPessoas, this.countQuartos);

        if (result.diarias.indexOf(this.countDiarias) < 0) {
              const sortedArray = result.diarias.sort((a, b) => b - a);

              for (const v of sortedArray) {
                  if (+v < this.countDiarias) {
                      this.countDiarias = +v;
                      this.iniciarTimeout();
                      return;
                  }
              }
              this.countDiarias++;
          } else {
              this.iniciarTimeout();
          }
      }

    calcularDiaria() {
        if (this.isFacilita) {
            this.calculaValores();
        }
    }

    onChangeDiaria(event) {
        this.countDiarias = +event;
        this.calculaValores();
    }

    maisPessoa() {
        this.countPessoas++;
        const result = this.propostaService.validarParametrosCalculo(this.countDiarias, this.countPessoas, this.countQuartos);

        if (result.pessoas.indexOf(this.countPessoas) < 0) {
          const sortedArray = result.pessoas.sort((a, b) => a - b);

          for (const v of sortedArray) {
            if (+v > this.countPessoas) {
              this.countPessoas = +v;
              this.iniciarTimeout();
              return;
            }
          }

          this.countPessoas--;
        } else {
          this.iniciarTimeout();
        }
      }

    menosPessoa() {
        if (this.countPessoas <= 2) {
          return;
        }

        this.countPessoas--;
        const result = this.propostaService.validarParametrosCalculo(this.countDiarias, this.countPessoas, this.countQuartos);

        if (result.pessoas.indexOf(this.countPessoas) < 0) {
          const sortedArray = result.pessoas.sort((a, b) => b - a);

          for (const v of sortedArray) {
            if (+v < this.countPessoas) {
              this.countPessoas = +v;
              this.iniciarTimeout();
              return;
            }
          }

          this.countPessoas++;
        } else {
          this.iniciarTimeout();
        }
      }

    async getPlanos() {
        const data = await this.produtoService.planos();
        this.planosDuplos = this.categoriaPlanoService.onlyDoubles(data, this.minDiaria);
        this.planosTriplos = this.categoriaPlanoService.onlyTriples(data, this.minDiaria);
        this.selectedCategoria = this.planosDuplos[0].codigoCategoria;
        const result = await this.categoriaPlanoService.planos();
        this.planosDuplos = this.categoriaPlanoService.onlyDoubles(result.data, this.minDiaria);
        this.planosTriplos = this.categoriaPlanoService.onlyTriples(result.data, this.minDiaria);
        this.planosAll = this.planosDuplos.concat(this.planosTriplos);
        this.selectedCategoria = this.planosDuplos[1].codigoCategoria;
        this.planos = this.planosDuplos;
        if (this.storageValido()) {
            this.selectedTypeValue = +this.getPropostaParaStorage().itensProposta[0].pessoas;
            this.planos = (+this.selectedTypeValue === 2) ? this.planosDuplos : this.planosTriplos;
            this.selectedCategoria = this.getPropostaParaStorage().itensProposta[0].codigoCategoria;
            this.countDiarias = this.getPropostaParaStorage().itensProposta[0].diarias;
        }
    }

    async onChangeCategoria(event) {
        this.selectedCategoria = event;
        await this.calculaValores();
    }

    async onChangeType(event) {
        this.selectedTypeValue = +event;
        this.planos =  (this.selectedTypeValue === 2) ? this.planosDuplos : this.planosTriplos;
        this.selectedCategoria = this.categoriaPlanoService.transitionType(this.selectedCategoria);
        await this.calculaValores();
    }

    mountTitulo() {
        return {
            cupom: (this.isCupomValido) ? this.cupom : '',
            cupomAceito: this.isCupomValido,
            itensProposta: this.mountItensProposta(),
            mensagemCupom: '',
            fidelizacaoCliente: true,
            valorAdesao: 'R$ 600,00',
            valorMensalidade: this.valorMensal,
            valorAdesaoDesconto: 0,
            valorMensalidadeDesconto: 0,
            quartoTriplo: (this.selectedTypeValue === 3) ? 1 : 0,
            quartoDuplo: (this.selectedTypeValue === 2) ? 1 : 0,
        };
    }

    mountItensProposta() {
        return [{
            cupom:  this.cupom,
            cupomAceito: false,
            fidelizacaoCliente: this.fidelizacaoCliente,
            itensProposta: [{
                categoriaTitulo: this.plano.descricao,
                codigoCategoria: this.plano.codigoCategoria,
                diarias: this.countDiarias,
                pessoas: (this.selectedTypeValue === 2) ? 2 : 3,
                quartos: 1,
                valor: this.plano.qtdDiarias[0].valor,
                valoresTitulosDetalhado: [{
                    codigoCategoriaSales: this.plano.codigoCategoriaSales,
                    categoriaDescricao: this.plano.descricao,
                    codigoCategoria: this.plano.codigoCategoria,
                    descricao: this.plano.qtdDiarias[0].descricao,
                    qtdTitulos: this.plano.qtdDiarias.length,
                    quantidadeDiarias: this.plano.qtdDiarias[0].quantidadeDiarias,
                    valor: this.plano.qtdDiarias[0].valor
                }]
            }
        ]}];
    }

    setPropostaText(proposta ?: Proposta) {
        let codigoCategoria;
        let valor;
        valor = this.propostaStorage.valorMensalidade;
        codigoCategoria = this.propostaStorage.itensProposta[0].valoresTitulosDetalhado[0].codigoCategoria;
        if (proposta !== null) {
            codigoCategoria = proposta.itensProposta[0].valoresTitulosDetalhado[0].codigoCategoria;
            valor = proposta.valorMensalidade;
        }
        const totalPessoa = (proposta.quartoDuplo) ? 'duas' : 'três';
        const text = this.setText(codigoCategoria, valor, totalPessoa, this.countDiarias);
        this.text1 = text.text1;
        this.text2 = text.text2;
    }

    setText(codigoCategoria: string, valor: string, totalPessoa: string, countDiarias: number) {
        const text1 = this.categoriaPlanoService.getText(0, codigoCategoria, valor);
        let text2 = this.categoriaPlanoService.getText(2, codigoCategoria, valor);
        text2 = text2.replace('de 7 diárias', 'a partir de ' + countDiarias + ' diárias');
        text2 = text2.replace('duas pessoas.', totalPessoa + ' pessoas.');
        return { text1, text2};
    }

    getUtmParams() {
        return JSON.parse(localStorage.getItem('mtl.utm'));
    }

    getMensalidade(propostaResult) {
        if (this.isCupomValido != null && this.isCupomValido && this.cupom) {
            return propostaResult.valorMensalidadeDesconto;
        }
        return propostaResult.valorMensalidade;
    }

    getInfoCarrinho() {
        const proposta = JSON.parse(localStorage.getItem('mtl.proposta'));
        return {
          valorMensalidade: this.getMensalidade(proposta),
          valorMensalidadeOriginal: proposta.valorMensalidade,
          valorMensalidadeDesconto: proposta.valorMensalidadeDesconto,
          categoriaTitulo: proposta.itensProposta[0].categoriaTitulo,
          diarias: proposta.itensProposta[0].diarias
        };
    }

    decodePayloadJWT(token: string): any {
        try {
            if (token) {
                return jwt_decode(token);
            }
            return null;
        } catch (e) {
            return null;
        }
    }

    decodeToken(token: string) {
        return this.decodePayloadJWT(token);
    }

    getEmailToken(token: string) {
        const decodedToken = this.decodeToken(token);
        if (decodedToken && decodedToken.email) {
            return decodedToken.email;
        }
        return '';
    }

    private getValorMensalPorCodigoCategoria(codigoCategoria: string, data: any) {
        const countDiarias = data.diarias;
        let quantidadesDiarias = [];
        let valorMensalString = '';
        let valorMensal = 0;
        const categorias = this.planosAll.filter(value => value.codigoCategoria === codigoCategoria);
        if (categorias.length > 0) {
            quantidadesDiarias = categorias[0].qtdDiarias.filter(
                value => value.codigoCategoria === codigoCategoria && value.quantidadeDiarias === countDiarias
            );
            if (quantidadesDiarias.length > 0) {
                valorMensal = quantidadesDiarias[0].valor;
                valorMensalString = this.categoriaPlanoService.monthlyValueString(quantidadesDiarias[0].descricao);
            }
            if (quantidadesDiarias.length === 0 && data) {
                if (countDiarias < 7 && countDiarias !== 5) {
                    valorMensal = data.valor;
                    valorMensalString = this.categoriaPlanoService.monthlyValueString(data.valoresTitulosDetalhado[0].descricao);
                }
            }
        }
        if (this.isCupomValido) {
            valorMensalString = this.calcularDesconto(valorMensal);
            valorMensalString = this.transformMoney(valorMensalString);
        }
        return { valorMensal, valorMensalString };
    }

    transformResultInCarrinho(data: any[]): ICarrinho[] {
        const carrinho: ICarrinho[] = [];
        for (let i = 0; i < data.length; i++) {
            const result = data[i];
            const valoresTitulosDetalhado = result.valoresTitulosDetalhado[0];
            const categoriaTitulo = valoresTitulosDetalhado.categoriaDescricao;
            const codigoCategoria = valoresTitulosDetalhado.codigoCategoria;
            const selectedCategoria = (codigoCategoria.length === 1) ? `0${codigoCategoria}` : codigoCategoria;
            carrinho.push({
                id: i,
                titulo: categoriaTitulo.replace('Triplo', ''),
                text1: null,
                text2: null,
                valorMensal: this.getValorMensalPorCodigoCategoria(selectedCategoria, result).valorMensal,
                valorMensalString: this.getValorMensalPorCodigoCategoria(selectedCategoria, result).valorMensalString,
                categoriaTitulo,
                selectedCategoria,
                countDiarias: result.diarias,
                totalDiarias: null,
                totalValorMensal: null,
                selectedTypeValue: result.pessoas,
                planos: (result.pessoas === 2) ? this.planosDuplos : this.planosTriplos,
                last: false,
            });
        }
        carrinho.forEach( element => {
            if (element.id === carrinho[carrinho.length - 1].id) {
                element.last = true;
            }
        });
        return carrinho;
    }

    async setProposta(proposta) {
        this.carrinhos = this.transformResultInCarrinho(proposta.itensProposta);
        this.propostaStorage = proposta;
        this.isConforto = this.categoriaTitulo === 'CONFORTO';
        this.isFacilita = this.categoriaTitulo !== 'CONFORTO' && this.categoriaTitulo !== 'TRANQUILIDADE';
        if (this.isFacilita) {
            await this.getPlanos();
        }
        this.cupom = proposta.cupomAceito && proposta.cupom ? proposta.cupom : '';
        if (proposta && proposta.email) {
            this.emailCliente = proposta.email;
        }
    }

    fidelizacaoClienteEmit($event) {
        this.fidelizacaoCliente = $event;
        const proposta = this.propostaStorage;
        proposta.fidelizacaoCliente = this.fidelizacaoCliente;
        this.addPropostaParaStorage(proposta);
    }
}
